import { UserDashboardEntry } from './types'

export const subscribeToUserDashboard = () =>
  ({ type: 'userDashboard.subscribe' } as const)
type SubscribeToUserDashboard = ReturnType<typeof subscribeToUserDashboard>

export const unsubscribeFromUserDashboard = () =>
  ({ type: 'userDashboard.unsubscribe' } as const)
type UnsubscribeFromUserDashboard = ReturnType<
  typeof unsubscribeFromUserDashboard
>

export const updateUserDashboard = (userDashboard: UserDashboardEntry[]) =>
  ({
    type: 'userDashboard.updateUserDashboard',
    payload: { userDashboard }
  } as const)
type UpdateUserDashboard = ReturnType<typeof updateUserDashboard>

export type UserDashboardAction =
  | SubscribeToUserDashboard
  | UpdateUserDashboard
  | UnsubscribeFromUserDashboard
